import React from 'react'
import { useIntl } from 'react-intl'
import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core'
import CancelButton from 'app/components/buttons/CancelButton'
import DeleteButton from 'app/components/buttons/DeleteButton'
import useMobileStyle from 'app/components/mobileModal/mobileModalStyle'
import { Transition } from './TopicCardDialog'
import { makeStyles } from '@material-ui/core/styles'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import './styles/notification-topic-table.css'
import * as R from 'ramda'
import effects from 'app/effects/effects'
import { useDispatch } from 'react-redux'
import MessageAlert from 'app/components/MessageAlert'
import { useState } from 'react'

const useStyles = makeStyles({
  deleteTopicDialog: {
    '& .MuiPaper-root': {
      width: '380px',
      padding: '10px 15px 15px 0',
    },
  },
})

export default (props) => {
  const { isOpen = false, onClose, topic, subscriberId, onChange } = props
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const dialogTitle = formatMessage(
    {
      id: 'topics.dialog.delete.title',
    },
    { topicName: R.prop('name', topic) },
  )

  const description = formatMessage(
    {
      id: 'topics.dialog.delete.description',
    },
    { selectedCount: subscriberId.length },
  )

  const deleteTopicDialog = useStyles()
  const mobileClasses = useMobileStyle()

  const handleClickDelete = async (id) => {
    try {
      await setIsLoading(true)
      await effects.apis.unfollowTopic({
        topicsId: R.prop('id', topic),
        subscriberIds: id.toString(),
      })
      await onChange()
      await setIsLoading(false)
      onClose()
    } catch (error) {
      await setIsLoading(false)
      dispatch(
        MessageAlert.showError({
          message: formatMessage({ id: 'error.general' }),
        }),
      )
    }
  }

  return (
    <ResponsiveDialog
      fullScreen={false}
      onEscapeKeyDown={() => {
        onClose()
      }}
      open={isOpen}
      TransitionComponent={Transition}
      maxWidth="xs"
      className={deleteTopicDialog.deleteTopicDialog}
    >
      <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent style={{ marginTop: '-10px' }}>
        <DialogContentText
          id="alert-dialog-description"
          style={{ color: 'black' }}
        >
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <CancelButton
          onClick={() => {
            onClose()
          }}
          isLoading={isLoading}
          disabled={isLoading}
          className={mobileClasses.modalBtn}
          style={{
            width: '80px',
            height: '35px',
          }}
        />
        <DeleteButton
          onClick={() => handleClickDelete(subscriberId)}
          isLoading={isLoading}
          disabled={isLoading}
        />
      </DialogActions>
    </ResponsiveDialog>
  )
}
